module.exports = __webpack_public_path__ + "4a6cabaf418eeb4d.png";